import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Payment() {
  const location = useLocation();
  const navigate = useNavigate();
  const { paymentUrl } = location.state || {};

  useEffect(() => {
    if (paymentUrl) {
      // Open payment URL in new tab
      window.open(paymentUrl, '_blank');
    } else {
      navigate('/checkout');
    }
  },);

  if (!paymentUrl) {
    return null;
  }

  return (
    <div className="pt-24 flex flex-col w-full h-full items-center bg-[#FBFCFF]">
      <div className="flex flex-col items-center gap-6 p-8 bg-white rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-semibold text-[#171725]">Payment Link Generated</h2>
        <p className="text-gray-600 text-center">
          A new tab has been opened for payment. If it didn't open or you closed it accidentally, click the button below.
        </p>
        <div className="flex flex-col gap-4 w-full">
          <a 
            href={paymentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-[#FBC02D] text-white text-center py-3 rounded-lg font-semibold hover:bg-[#e5ad28] transition-colors"
          >
            Proceed to Payment
          </a>
        </div>
      </div>
    </div>
  );
}

export default Payment; 